import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentModel, Favorite } from '../models';
import { Subject, switchMap, tap } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  private favoritesChanged$ = new Subject<void>();
  public favoritesChanged = this.favoritesChanged$.asObservable();

  constructor(
    private http: HttpClient,
    private userService: UserService,
    @Inject('environment') private environment: EnvironmentModel
  ) {}

  getFavorites() {
    return this.userService.currentUser.pipe(
      switchMap((user) => {
        return this.http.get<Favorite[]>(
          `${this.environment.apiUrl}/favorite/user/${user.id}`
        );
      })
    );
  }

  addToFavorites(referenceId: string) {
    return this.userService.currentUser.pipe(
      switchMap((user) => {
        return this.http.post<Favorite>(`${this.environment.apiUrl}/favorite`, {
          referenceId,
          userId: user.id,
        });
      }),
      tap(() => this.favoritesChanged$.next())
    );
  }

  removeFormFavorites(favoriteId: string) {
    return this.http.delete<Favorite>(
      `${this.environment.apiUrl}/favorite/${favoriteId}`
    ).pipe(
      tap(() => this.favoritesChanged$.next())
    );
  }

  removeFromFavoritesByReference(referenceId: string) {
    return this.userService.currentUser.pipe(
      switchMap((user) => {
        return this.http.delete<Favorite>(
          `${this.environment.apiUrl}/favorite/user/${user.id}/reference/${referenceId}`
        );
      }),
      tap(() => this.favoritesChanged$.next())
    );
  }
}
